export const colorSchemes = {
  light: {
    palette: {
      black: {
        main: "#000000",
        light: "#4f4f4f",
        dark: "#000000",
        contrastText: "#ffffff",
      },
      white: {
        main: "#ffffff",
        light: "#ffffff",
        dark: "#dcdcdc",
        contrastText: "#25272c",
      },
      blue: {
        main: "#d4edff",
        light: "#eff9ff",
        dark: "#79d2ff",
        contrastText: "#0054fc",
      },
      // primary: {
      //   main: "#010e3d",
      //   light: "#0045ff",
      //   dark: "#010e3d",
      //   contrastText: "#ffffff",
      //   "50": "#e5f4ff",
      //   "100": "#d0ebff",
      //   "200": "#aad9ff",
      //   "300": "#77bcff",
      //   "400": "#428eff",
      //   "500": "#185eff",
      //   "600": "#0042ff",
      //   "700": "#0045ff",
      //   "800": "#003de0",
      //   "900": "#022cad",
      //   "950": "#010e3d",
      // },
      primary: {
        main: "#111111",
        light: "#4f4f4f",
        dark: "#111111",
        contrastText: "#ffffff",
        "50": "#f6f6f6",
        "100": "#e7e7e7",
        "200": "#d1d1d1",
        "300": "#b0b0b0",
        "400": "#888888",
        "500": "#6d6d6d",
        "600": "#5d5d5d",
        "700": "#4f4f4f",
        "800": "#454545",
        "900": "#3d3d3d",
        "950": "#111111",
      },
      secondary: {
        main: "#0241c4",
        light: "#178eff",
        dark: "#0b2760",
        contrastText: "#ffffff",
        "50": "#ecf8ff",
        "100": "#d4edff",
        "200": "#b3e1ff",
        "300": "#7fd0ff",
        "400": "#42b3ff",
        "500": "#178eff",
        "600": "#006cff",
        "700": "#0054fc",
        "800": "#0241c4",
        "900": "#093e9f",
        "950": "#0b2760",
      },
      info: {
        main: "#178eff",
        light: "#b3e1ff",
        dark: "#0054fc",
        contrastText: "#ffffff",
      },
      success: {
        main: "#4caf50",
        light: "#e3f5e3",
        dark: "#2d6830",
        contrastText: "#ffffff",
      },
      warning: {
        main: "#ffc107",
        light: "#fffbc5",
        dark: "#bb6902",
        contrastText: "#ffffff",
      },
      error: {
        main: "#f44336",
        light: "#ffe3e1",
        dark: "#be2217",
        contrastText: "#ffffff",
      },
      disabled: {
        main: "#adadad",
        light: "#c8c8c8",
        dark: "#9cadb6",
        contrastText: "#ffffff",
      },
      grey: {
        "50": "#f7f8f8",
        "100": "#edeef1",
        "200": "#d8dbdf",
        "300": "#b6bac3",
        "400": "#8e95a2",
        "500": "#6b7280",
        "600": "#5b616e",
        "700": "#4a4e5a",
        "800": "#40444c",
        "900": "#383a42",
        "950": "#25272c",
      },
      slate: {
        "50": "#f9fafb",
        "100": "#f2f4f5",
        "200": "#e7ebed",
        "300": "#d3dbdf",
        "400": "#b6c3ca",
        "500": "#9cadb6",
        "600": "#7f939e",
        "700": "#6a7c86",
        "800": "#596770",
        "900": "#49535a",
        "950": "#2e373d",
      },
      lavender: {
        main: "#b66afe",
        light: "#ead4ff",
        dark: "#9630ed",
        contrastText: "#ffffff",
      },
      conifer: {
        main: "#b1e457",
        light: "#ebf8cf",
        dark: "#82bf23",
        contrastText: "#ffffff",
      },
    },
  },
};
